import { forwardRef, useEffect } from "react";
import IntroText from "./IntroText";
import SkillsSphere from "./SkillsSphere";
import { setActiveSection } from "../../store";
import { useDispatch } from "react-redux";

function AboutSection({ preventIntersectionObserver }, ref) {
  const dispatch = useDispatch();

  /**
   * This is a callback to begin the observation of the div when the component first renders.
   */
  useEffect(() => {
    /**
     * An interaction observer object that allows us to monitor any interaction between the section's
     * div, and the viewport (visible area). It will make the section active when it intersects the
     * viewport.
     */
    const observer = new IntersectionObserver(
      (data) => {
        if (!preventIntersectionObserver.current && data[0].isIntersecting)
          dispatch(setActiveSection("about"));
      },
      {
        root: null,
        threshold: [0.55],
        rootMargin: "0px 5px 0px 0px",
      }
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, dispatch, preventIntersectionObserver]);

  return (
    <div
      style={{ height: "calc(95vh - 67px)" }}
      className="w-full relative min-h-[480px]"
      ref={ref}
    >
      <IntroText className="absolute top-6 left-0 right-0 mx-auto w-max" />
      <SkillsSphere
        className="absolute left-0 right-0 mx-auto bottom-0"
        diameter={270}
      />
    </div>
  );
}

export default forwardRef(AboutSection);
